import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      borderRadius: theme.shape.borderRadiusSmall,
      padding: theme.spacing(0.5, 1.5),
      letterSpacing: '0.08em',
      fontSize: theme.typography.pxToRem(10),
      lineHeight: 1,
      fontWeight: theme.typography.fontWeightSemiBold,
      textTransform: 'uppercase',

      '&$approved': {
        backgroundColor: COLORS.success.light,
        color: COLORS.success.active,
      },

      '&$doNotUse': {
        backgroundColor: COLORS.error.light,
        color: COLORS.error.active,
      },
    },
    approved: {},
    doNotUse: {},
  }),
  { name: 'ApprovalTypeBadge' }
);
